<template>
    <div>
         <pt-page-title title="新建链接"></pt-page-title>
        <pt-link-form ref="form" @submitSuccess="submitSuccess" @getSubmitLoading="getSubmitLoading"></pt-link-form>
        <div class="button-div">
            <el-button type="primary" @click="submit" :buttonLoading="buttonLoading">生成链接</el-button>
            <el-button type="primary" plain @click="cancel">取消</el-button>
        </div>
    </div>
</template>
<script>
import ptLinkForm from './withData'
export default {
  components: {
    ptLinkForm
  },
  data () {
    return {
      buttonLoading: false
    }
  },
  methods: {
    submit () {
      this.$refs.form.submit()
    },
    cancel () {
      history.go(-1)
    },
    getSubmitLoading () {
      this.buttonLoading = true
    },
    submitSuccess () {
      this.buttonLoading = false
    }
  }
}
</script>
<style lang="less">

</style>
